module.exports = __webpack_public_path__ + "img/logo-bottom-hover.e0723360.png";